import ArticlePage from "@/pages/article/ArticlePage";

export default function UltimateJackets() {
  return <ArticlePage slug="ultimate-jackets-outerwear-guide" />;
}